import React , {useState, useEffect} from 'react';
import { connect } from 'react-redux';
import BtnSubmit from 'app/Components/Shared/Buttons/BtnSubmit';

const ButtonNextStep = ({
  onclick,
  text,
  disabled = false,
  className = '',
  errorText,
  currentStep,
  setCurrentStep,
  nextStep,
  saveToHistory,
  pushToHistory,
  clearHistory,
  clearHistoryInd = false,
  buttonColor = 'primaryColor',
}) => {

  const [canProceed, setCanProceed] = useState(true);
  const [handled, setHandled] = useState(false);


  async function handleNextStep() {
    setHandled(true);
    let result = true;
    result = await onclick();
    setCanProceed(result);

    if (!result) return;
    
    if (clearHistoryInd) {
      clearHistory();
    } else {
      saveToHistory(currentStep);
    }

    if (nextStep) {
      setCurrentStep(nextStep);
    }
  }

  return (
    <div className={`button-next-step ${className}`}>
      {!canProceed && handled && (
        <div className="error center">{errorText}</div>
      )}

      <BtnSubmit
        onclick={handleNextStep}
        text={text || "המשך"}
        disabled={disabled}
        className={buttonColor}
      />
    </div>
  );
};


export default ButtonNextStep;